import React from "react";
import { Nav, NavItem } from "../components/Navigation/Nav";
import { portfolioData } from '../data/portfolio';
import profile from "../assets/img/profile.jpg";

const SideNav = () => {
    const handleSocialClick = (platform, url) => {
        window.gtag('event', 'click', {
            'event_category': 'Social',
            'event_label': platform,
            'platform': platform,
            'url': url
        });
    };

    const { about, social } = portfolioData;

    const iconMap = {
        github: "M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z",
        linkedin: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
        email: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z",
        twitter: "M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z",
        devto: "M7.42 10.05c-.18-.16-.46-.23-.84-.23H6l.02 2.44.04 2.45.56-.02c.41 0 .63-.07.83-.26.24-.24.26-.36.26-2.2 0-1.91-.02-1.96-.29-2.18zM0 4.94v14.12h24V4.94H0zM8.56 15.3c-.44.58-1.06.77-2.53.77H4.71V8.53h1.4c1.67 0 2.16.18 2.6.9.27.43.29.6.32 2.57.05 2.23-.02 2.73-.47 3.3zm5.09-5.47h-2.47v1.77h1.52v1.28l-.72.04-.75.03v1.77l1.22.03 1.2.04v1.28h-1.6c-1.53 0-1.6-.01-1.87-.3l-.3-.28v-3.16c0-3.02.01-3.18.25-3.48.23-.31.25-.31 1.88-.31h1.64v1.3zm4.68 5.45c-.17.43-.64.79-1 .79-.18 0-.45-.15-.67-.39-.32-.32-.45-.63-.82-2.08l-.9-3.39-.45-1.67h.76c.4 0 .75.02.75.05 0 .06 1.16 4.54 1.26 4.83.04.15.32-.7.73-2.3l.66-2.52.74-.04c.4-.02.73 0 .73.04 0 .14-1.67 6.38-1.8 6.68z"
    };

    return (
        <div
            className="max-md:hidden md:flex flex-col w-72 h-screen fixed left-0 top-0 bg-gray-900 bg-gradient-to-b from-gray-900 to-black text-white shadow-2xl z-50 overflow-y-auto custom-scrollbar"
            style={{ backgroundColor: '#111827' }}
        >
            {/* Profile Section */}
            <div className="mx-4 mt-8 p-6 bg-white/5 rounded-2xl backdrop-blur-sm border border-white/10 transition-all hover:bg-white/10 group">
                <div className="relative mx-auto mb-4 w-32 h-32">
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full opacity-0 group-hover:opacity-50 blur-lg transition-opacity duration-500"></div>
                    <img
                        src={profile}
                        alt={about.name}
                        className="relative w-full h-full rounded-full border-4 border-white/20 object-cover shadow-xl transform transition-transform duration-300 group-hover:scale-105 group-hover:border-white/40"
                    />
                </div>
                <div className="text-center">
                    <h3 className="text-lg font-bold text-white tracking-wide mb-1 font-display uppercase">{about.name}</h3>
                    <p className="text-[10px] font-bold text-gray-400 tracking-[0.2em] uppercase">{about.role}</p>
                </div>
            </div>

            {/* Social Icons */}
            <div className="flex justify-center gap-5 py-6">
                {social.slice(0, 5).map((item, index) => (
                    item.icon && iconMap[item.icon] ? (
                        <a
                            key={index}
                            href={item.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-gray-400 hover:text-white transform hover:scale-125 transition-all duration-300 p-1"
                            aria-label={item.name}
                            onClick={() => handleSocialClick(item.name, item.url)}
                        >
                            <svg height="18" viewBox="0 0 24 24" fill="currentColor" width="18">
                                <path d={iconMap[item.icon]}></path>
                            </svg>
                        </a>
                    ) : null
                ))}
            </div>

            {/* Navigation Links */}
            <div className="flex-1 px-4 pb-8">
                <Nav>
                    <NavItem iconCLass="fa fa-globe" link="welcome">Home</NavItem>
                    <NavItem iconCLass="fa fa-pencil" link="about">About Me</NavItem>
                    <NavItem iconCLass="fa fa-angellist" link="experience">Experience</NavItem>
                    <NavItem iconCLass="fa fa-paperclip" link="blogs">Blogs</NavItem>
                    <NavItem iconCLass="fa fa-file" link="resume">My CV</NavItem>
                    <NavItem iconCLass="fa fa-link" link="contact">Contact Me</NavItem>
                </Nav>
            </div>

            <div className="p-4 text-center text-[10px] text-gray-600 border-t border-gray-800/50">
                <p>&copy; {new Date().getFullYear()} Subhransu Maharana</p>
            </div>
        </div>
    );
}

export default SideNav;